
export const topComments = {
  init(options) {
    options = $.extend(
      {
        selector: '.m1-top-comments',
        bodySelector: '.m1-top-comments__body',
        config: null,
      },
      options,
    );

    if (!options?.config?.active) return;

    this.render(options);
  },

  async render(options) {
    const $container = $(options.selector);
    const $containerBody = $container.find(options.bodySelector);
    if (!$containerBody.length) return;

    const result = await this.getData(options);
    const items =
      result &&
      result.data &&
      result.data.data &&
      result.data.data.comments &&
      result.data.data.comments.nodes
        ? result.data.data.comments.nodes
        : [];

    if (!result.status || !items.length) {
      $container.addClass('m1-top-comments--empty');
      return;
    }

    $containerBody.html(this.getMarkup(items));
  },

  getMarkup(items) {
    return `<div 
      class="m1-top-comments-items" 
      data-lazy-content="comments-drawer-tpl"
    >
      ${items.map((item) => this.getItemMarkup(item)).join('\n')}
    </div>`;
  },

  getItemMarkup(item) {
    return `<div class="m1-top-comments-item">
      <div class="m1-top-comments-item__head">
        ${this.getAvatar(item.author)}

        <div class="m1-top-comments-item__commenter">
          <span class="m1-top-comments-item__commenter-username">${
            item.author.username
          }</span>
          <span class="m1-top-comments-item__commenter-date">${this.formatDate(
            item.createdAt,
          )}</span>
        </div>
      </div>

      <div class="m1-top-comments-item__body">
        ${item.body}
      </div>
    </div>`;
  },

  formatDate(date) {
    const data = document.body.dataset;
    const curentEdtn = data['edtn'];
    const locale = curentEdtn == 'ra_us' ? 'en-US' : 'fr-FR';
    const options = {
      dateStyle: 'medium',
      timeStyle: 'short',
    };

    return new Intl.DateTimeFormat(locale, options).format(new Date(date));
  },

  getAvatar(author) {
    if (!author.avatar) return '';

    return `<img 
      src="${author.avatar}" 
      class="m1-top-comments-item__img"
      width="30px"
      height="30px"
      alt="${author.username}"
    />`;
  },

  async getData(options) {
    var $comments = $(options.selector).not('[data-comments-ready="1"]');
    if (!$comments.length) return;

    const data = $comments.data();
    const { articleId } = data;

    const { edtn } = document.body.dataset;

    return $.get({
      url: `https://y14vyglkj5.execute-api.us-east-1.amazonaws.com/default/coral-comment-proxy?storyId=${articleId}&editionCode=${edtn}`,
    });
  },
};
